<ng-content #form></ng-content>
<app-product-card
  (delete)="delete.emit($event)"
  [program]="program"
  [teamPath]="teamPath"
  [type]="BookingStorageEnum.rehabilitation"
>
  <div class="col-12 col-md-7 d-flex flex-column">
    <div class="d-flex gap-2 flex-wrap mb-3">
      <div class="d-flex align-items-center gap-1 border-end pe-2">
        <i class="bi bi-geo-alt"></i>
        <div class="text-muted">{{ program.clinic.city }}</div>
      </div>
      <div class="d-flex align-items-center gap-1 border-end pe-2">
        <i class="bi bi-person"></i>
        <div class="text-muted">
          {{ program.direction | transloco }}
        </div>
      </div>
      @if (!program.hideDuration) {
        <div class="d-flex align-items-center gap-1">
          <i class="bi bi-clock"></i>
          <div [innerHTML]="{ format: program.format, formatTime: program.formatTime } | formatTime"></div>
        </div>
      }
      @if (program.inclusivity) {
        <div class="d-flex align-items-center gap-1 border-start ps-2">
          <i class="bi bi-heart"></i>
          <div class="text-muted">
            {{ 'inclusivity' | transloco }}
          </div>
        </div>
      }
    </div>

    @if (program.subFormat === RehabilitationSubFormatEnum.hospital) {
      <div class="d-flex align-items-center gap-2">
        <span class="text-muted">{{ 'room_type' | transloco }}:</span>
        <span class="fw-bolder">{{ program.subFormat | transloco }}</span>
      </div>
    }
    @if (program.equipment) {
      <div class="d-flex align-items-center gap-2">
        <span class="text-muted">{{ 'equipment' | transloco }}:</span>
        <span class="fw-bolder">{{ program.equipment }}</span>
      </div>
    }
    @if (program.inclusivity) {
      <div class="d-flex align-items-center gap-2">
        <span class="text-muted">{{ 'inclusivity' | transloco }}</span>
        <span class="fw-bolder">
          @for (item of program.inclusivity; track $index) {
            {{ item | transloco }},
          }
        </span>
      </div>
    }
    <div class="d-flex align-items-center gap-2">
      <span class="text-muted">{{ 'expected_results' | transloco }}:</span>
      <span class="fw-bolder">
        @if (program.results) {
          {{ program.results }}
        } @else {
          {{ 'general_health_improvement' | transloco }}
        }
      </span>
    </div>
  </div>
</app-product-card>
